import { useField } from 'formik';
import React, { ChangeEvent, FC } from 'react';

// Components
import FormikError from '../FormikError';
import { Icon } from '../../common';

interface Props {
  name: string;
  label: string;
}

const FormikFilePicker: FC<Props> = ({ name, label }) => {
  const [field, meta, helpers] = useField<File | null>(name);
  const id = `aea-form-filepicker-${name}`;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const files = e.currentTarget.files;
    if (files && files.length > 0) {
      helpers.setValue(files[0]);
    }
  };

  const handleOnFileRemove = (e: React.MouseEvent<HTMLElement>) => {
    helpers.setValue(null);
  };

  return (
    <div className="aea-form-filepicker">
      {field.value ? (
        <div className="aea-form-filepicker__container">
          <span>{field.value.name}</span>
          <button className="button-reset" onClick={handleOnFileRemove}>
            <Icon type="trash" className="aea-form-icon--md" />
          </button>
        </div>
      ) : (
        <div>
          <label className="aea-form-filepicker__container" htmlFor={id}>
            <Icon type="attachment" className="aea-form-icon--md" />
            {}
            <span>{label}</span>
          </label>
          <input type="file" id={id} name={name} onChange={handleChange} />
        </div>
      )}
      {meta.touched && meta.error && <FormikError name={name} />}
    </div>
  );
};

export default FormikFilePicker;
